import { Component, OnInit } from '@angular/core';
import { User } from '../../_models';
import { AuthenticationService } from '../../_services/authentication.service';
import { UsersAndGroupsService } from 'src/app/_services/users-and-groups.service';
import { AppConfig } from 'src/assets/config/config/app-config';

@Component({ templateUrl: 'home.component.html' })

export class ConfigHomeComponent implements OnInit {
    currentUser: User;
    users = [];
    navLinks: any[];
    activeLinkIndex = -1;
    userGroups: string[]
    isAdmin: boolean = false
    isRecordsManager: boolean = false
    isRulesManager: boolean = false
    showRedaction: boolean = false;
    aclGroup:any =  this.config.getACLGroup().settings;

    constructor(
        private authenticationService: AuthenticationService,
        private config: AppConfig,
        private groupService: UsersAndGroupsService
    ) {
        this.currentUser = this.authenticationService.currentUserValue;
        this.userGroups = authenticationService.userGroupsValue
    }

    ngOnInit() {
        if (this.userGroups != null) {
            var adminGroup            
            this.groupService.getAdminGroupName().subscribe(admin => {
                adminGroup = admin
                var recordsManagementAdminGroup = this.config.getRecordsManagementAdminGroup()
                var rulesAdminGroup = this.config.getRulesAdminGroup()
                this.showRedaction = this.config.getConfig('showRedaction');
                this.userGroups.forEach(group => {
                    // switch (group) {
                    //     case rulesAdminGroup: this.isRulesManager = true;
                    //         break;
                    //     case adminGroup: this.isAdmin = true;
                    //         break;
                    //     case recordsManagementAdminGroup: this.isRecordsManager = true;
                    //         break
                    // }
                    if (adminGroup.includes(group)) {
                        this.isRulesManager = false;
                        this.isAdmin = true;
                        this.isRecordsManager = true;
                    }
                })
            })
        }
    }
}